export const ISSUE_NAVIGATOR_URL: string = `/issues/?jql=${encodeURIComponent(
	'created >= -30d order by created DESC',
)}`;
